import { DeclinationMnemonic } from '../../model/resource/declinationMnemonic';

export const EXPERIENCE_RANGE_IN_YEARS = 20;

// ToDo: move to core.server (resource/dictionaries)
export const createExperienceDictionary = (declination: (number: number, mnemonic: DeclinationMnemonic) => string) => {
  return Array.from(new Array(EXPERIENCE_RANGE_IN_YEARS + 1), (_, index) => ({
    value: index,
    label: !index
      ? 'Нет опыта'
      : `${index} ${declination(index, DeclinationMnemonic.Year)}${index === EXPERIENCE_RANGE_IN_YEARS ? ' и более' : ''}`,
  }));
};
